import './Footer.css';
import React from "react";
import { Link } from 'react-router-dom';

function Footer(props) {

    return (
        <div className="footer">
            <footer className="footerContainer">
                <nav>
                    <h1 className="footerHeader"> SITE NAVIGATOR</h1>
                    <ul className="center row">
                        <li><Link className="footerItem" to="/">home</Link></li>
                        <li><Link className="footerItem" to="/about">about</Link></li>
                        <li><Link className="footerItem" to="/stories">stories</Link></li>
                        <li><Link className="footerItem" to="/app">app</Link></li>
                    </ul>
                </nav>
                <div className="footerBottom">
                    <p className="footerSubText"> © 2026 Cerise Technology LLC </p>
                    <p className="footerSubText"> one of fourteen is a gen-ai free product - <a className="href" href="https://cerise-technology.com/ai-free-commitment"> learn more </a></p>
                </div>
            </footer>
        </div>
    )
}

export default Footer;